import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type LWApiPublicSecureDataShareListResultRawI } from '@liquidweb-dev/club-sauce/public/secureDataShare/index.raw';
import type {
	LWApiPublicSecureDataShareTicketLinkCreateParamsRawI,
	LWApiPublicSecureDataShareTicketLinkCreateResultRawI,
} from '@liquidweb-dev/club-sauce/public/secureDataShare/ticketlink/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { SECURE_DATA_SHARE_LIST_QUERY_KEY } from 'modules/queries/secureDataShare/useList';

const useSecureDataShareTicketLinkCreate = () => {
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicSecureDataShareTicketLinkCreateResultRawI,
		ApiErrorI,
		LWApiPublicSecureDataShareTicketLinkCreateParamsRawI
	>({
		mutationFn: (params) =>
			api.secureDataShare.ticketlink.apiRaw.create(params),
		onSuccess: (_data, params) => {
			queryClient.invalidateQueries({
				queryKey: [SECURE_DATA_SHARE_LIST_QUERY_KEY],
			});

			queryClient.setQueriesData<LWApiPublicSecureDataShareListResultRawI>(
				{
					queryKey: [SECURE_DATA_SHARE_LIST_QUERY_KEY],
				},
				(old) => {
					if (!old) return old;

					const newItems = old.items.map((item) => {
						if (item.id.toString() === params.datashare_id.toString()) {
							return {
								...item,
								ticketNumbers: [
									...(item.ticketNumbers || []),
									{ ticket_number: params.ticket, case_id: '' },
								],
							};
						}
						return item;
					});

					return { ...old, items: newItems };
				},
			);
		},
	});
};

export default useSecureDataShareTicketLinkCreate;
